export enum ActionDescriptionType {
  None = 0,
  Get = 1,
  Post = 2,
  Callback = 3,
  Modal = 4,
  AnonymousCallback = 5,
}
